"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInputField = void 0;
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var styled_1 = __importDefault(require("@emotion/styled"));
var styled_system_1 = require("styled-system");
var react_currency_input_field_1 = __importDefault(require("react-currency-input-field"));
var UIComponents_1 = require("./UIComponents");
var TextInputField_1 = require("./TextInputField");
var Text_1 = require("./Text");
var CurrencyInputFieldView = function (_a) {
    var name = _a.name, label = _a.label, description = _a.description, sideDescription = _a.sideDescription, className = _a.className, maxLength = _a.maxLength, detectCurrencyFieldName = _a.detectCurrencyFieldName, options = _a.options, props = __rest(_a, ["name", "label", "description", "sideDescription", "className", "maxLength", "detectCurrencyFieldName", "options"]);
    var _b = (0, formik_1.useField)(name), field = _b[0], meta = _b[1], helper = _b[2];
    var fieldLength = String(field.value || "").length;
    var values = (0, formik_1.useFormikContext)().values;
    var detectedCurrency = function () {
        var _a;
        if (detectCurrencyFieldName in values) {
            return (_a = values[detectCurrencyFieldName]) === null || _a === void 0 ? void 0 : _a.value;
        }
        return null;
    };
    var formatOptions = options !== null && options !== void 0 ? options : {
        intlConfig: {
            locale: navigator.language,
            currency: detectedCurrency() || "USD",
        },
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(UIComponents_1.ui.Label, { label: label, description: description, sideDescription: sideDescription }),
        react_1.default.createElement(StyledCurrencyInput, __assign({}, formatOptions, props, { value: field.value, onValueChange: function (value) { return helper.setValue(value !== null && value !== void 0 ? value : null); }, error: !!(meta.error && meta.touched), defaultValue: props.defaultValue, step: props.step })),
        react_1.default.createElement(TextInputField_1.InfoRow, null,
            react_1.default.createElement(UIComponents_1.ui.ErrorMessage, { showError: !!(meta.touched && meta.error), message: meta.error }),
            maxLength !== undefined && (react_1.default.createElement(Text_1.Text, { mt: "4px", ml: "auto", pl: "4px", variant: "uiTiny500", color: fieldLength > maxLength ? "red700" : "gray600" }, "".concat(fieldLength, "/").concat(maxLength))))));
};
/**
 * Input field that formats currency values. Must be wrapped in a Formik provider.
 * @param {string} name - The field name, used as reference by formik
 * @param {string} label - Label for this input, used to provide context to the user
 * @param {string=} description - Secondary label used to provide additional context to the user
 * @param {string=} detectCurrencyFieldName - The name of a field in the same form that toggles the currency
 * @param {object} options - Optionally, an options object can be passed in with the same type as the underlying CurrencyInput props.
 *  If so, the entire component will favour these options over the default currency behaviour.
 */
exports.CurrencyInputField = (0, styled_1.default)(CurrencyInputFieldView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 320px;\n  ", "\n  ", "\n"], ["\n  width: 320px;\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.layout);
var StyledCurrencyInput = (0, styled_1.default)(react_currency_input_field_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), TextInputField_1.inputStyles, function (_a) {
    var error = _a.error;
    return error && UIComponents_1.ui.errorStyles;
});
var templateObject_1, templateObject_2;
